
const digest = 'c2c28b07a0c195714692bd21536eb18ecd558e9b0865a98a0850e9669ba50898';
const classes = {"wrapper":"_wrapper_1pb7a_1"};
const css = `._wrapper_1pb7a_1 {
  display: flex;
  gap: 24px;
  flex-direction: row;
  padding: 12px 10px;
  align-items: center;
  position: absolute;
  z-index: 2;
  background: #fff;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  